<template>
  <div class="uncertainty-analysis-container">
    <div class="tab-header">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'breakeven' }"
        @click="activeTab = 'breakeven'"
      >
        盈亏平衡分析
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'sensitivity' }"
        @click="activeTab = 'sensitivity'"
      >
        敏感性分析
      </button>
    </div>

    <div class="tab-content">
      <BreakevenAnalysis 
        ref="breakevenRef" 
        :style="{ display: activeTab === 'breakeven' ? 'block' : 'none' }" 
      />
      <SensitivityAnalysis 
        ref="sensitivityRef" 
        :style="{ display: activeTab === 'sensitivity' ? 'block' : 'none' }" 
      />
    </div>
  </div>
</template>

<script>
import BreakevenAnalysis from "./BreakevenAnalysis.vue";
import SensitivityAnalysis from "./SensitivityAnalysis.vue";

export default {
  name: "UncertaintyAnalysis",
  components: {
    BreakevenAnalysis,
    SensitivityAnalysis,
  },
  data() {
    return {
      activeTab: "breakeven",
    };
  },
  methods: {
    // 获取盈亏平衡分析图实例
    getBreakevenChart() {
      return this.$refs.breakevenRef?.breakevenChart;
    },
    // 获取敏感性分析图实例
    getSensitivityChart() {
      return this.$refs.sensitivityRef?.sensitivityChart;
    },
  },
};
</script>

<style scoped>
.uncertainty-analysis-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tab-header {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.tab-btn {
  padding: 10px 24px;
  border: none;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px 4px 0 0;
  margin-right: 2px;
}

.tab-btn:hover {
  color: #409eff;
  background-color: #ecf5ff;
}

.tab-btn.active {
  background-color: #409eff;
  color: #fff;
}

.tab-content {
  flex: 1;
  overflow: auto;
}
</style>
